import {call, put} from "redux-saga/effects";
import {
  setArea,
  setCity,
  setProcessing,
  setProvince, toggleStatus, toggleSwitch,
  updateArea,
  updateCity,
  updateProvince
} from "../../slices/locationSlice";
import {
  getAreasByCity,
  getCitiesByProvince,
  getProvinces, patchArea, patchCity,
  patchProvince, postArea, postCity, putArea,
  putCity, putLocation,
  putProvince
} from "../requests/locationService";
import {toast} from "react-toastify";
import {setAppLoading} from "../../slices/authTokenSlice";
import {requestNewAddress} from "../requests/nurseCampaignService";

export function* handleGetProvinces() { try {
    yield put(setProvince({loading: true}))
    yield put(setCity({loading: true}))
    yield put(setArea({loading: true}))

    const provinces = yield call(() => getProvinces())
    const cities = yield call(() => getCitiesByProvince(provinces.data[0].id))
    const areas = yield call(() => getAreasByCity(cities.data[0].id))
    yield put(setProvince({loading: false, data: provinces.data}))
    yield put(setCity({loading: false, data: cities.data}))
    yield put(setArea({loading: false, data: areas.data}))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setProvince({loading: false, error: errMsg}))
  }
}

export function* handleGetCitiesByProvince(action) {
  const {provinceId} = action.payload
  try {
    yield put(setCity({loading: true}))
    const cities = yield call(() => getCitiesByProvince(provinceId))
    const areas = yield call(() => getAreasByCity(cities.data[0].id))
    yield put(setCity({loading: false, data: cities.data}))
    yield put(setArea({loading: false, data: areas.data}))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setCity({loading: false, error: errMsg}))
  }
}

export function* handleGetAreasByCity(action) {
  const {cityId} = action.payload
  try {
    yield put(setArea({loading: true}))
    const response = yield call(() => getAreasByCity(cityId))
    yield put(setArea({loading: false, data: response.data}))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setArea({loading: false, error: errMsg}))
  }
}

export function* handlePutProvince(action) {
  yield put(setProcessing(true))
  const {provinceId, newName} = action.payload
  try {
    const response = yield call(() => putProvince(provinceId, newName))
    yield put(updateProvince({province: response.data}))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handlePostCity(action) {
  yield put(setProcessing(true))
  const {provinceId, cities} = action.payload
  try {
    const response = yield call(() => postCity(provinceId, cities))
    yield put(setCity({data: response.data, isAdding: true}))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handlePutCity(action) {
  yield put(setProcessing(true))
  const {cityId, newName} = action.payload
  try {
    const response = yield call(() => putCity(cityId, newName))
    yield put(updateCity({city: response.data}))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handlePostArea(action) {
  yield put(setProcessing(true))
  const {cityId, areas} = action.payload
  try {
    const response = yield call(() => postArea(cityId, areas))
    yield put(setArea({data: response.data, isAdding: true}))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handlePutArea(action) {
  yield put(setProcessing(true))
  const {areaId, updatedArea} = action.payload
  try {
    const response = yield call(() => putArea(areaId, updatedArea))
    yield put(updateArea({area: response.data}))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setProcessing(false))
  }
}

export function* handlePatchProvince(action) {
  yield put(setAppLoading(true));
  const {provinceId, value, isCampaign = false} = action.payload
  try {
    const {data} = yield call(() => patchProvince(provinceId, value, isCampaign))
    yield put(toggleSwitch({data, locationType: "Province", locationId: provinceId}))
    toast.success(`Province updated successfully!`)
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setAppLoading(false));
  }
}

export function* handlePatchCity(action) {
  yield put(setAppLoading(true));
  const {cityId, value, isCampaign = false} = action.payload
  try {
    const {data} = yield call(() => patchCity(cityId, value, isCampaign))
    yield put(toggleSwitch({data, locationType: "City", locationId: cityId}))
    toast.success(`City updated successfully!`)
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setAppLoading(false));
  }
}

export function* handlePatchArea(action) {
  yield put(setAppLoading(true));
  const {areaId, value,  isCampaign = false} = action.payload
  try {
    const {data} = yield call(() => patchArea(areaId, value, isCampaign))
    yield put(toggleSwitch({data, locationType: "Area", locationId: areaId}))
    toast.success(`Area updated successfully!`)
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setAppLoading(false));
  }
}

export function* handlePutLocation(action) {
  yield put(setAppLoading(true));
  try {
    yield call(() => putLocation(action.payload))
    toast.success(`Location updated in bulk successfully!`)
    yield put(toggleStatus(false));
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
  } finally {
    yield put(setAppLoading(false));
  }
}
